export default __webpack_public_path__ + "static/media/banner.0d055e93.png";